import React, { forwardRef, useContext } from "react"
import styled, { css } from "styled-components"
import tw from "twin.macro"
import { Icon, BlockQuote } from "components"
import { TileType } from "model/content"

import LanguageContext from "logic/context/language"
import { LastWordColoured } from "components/LastWordColoured"

type HomeTileProps = TileType

const TileContainer = styled.div`
  ${tw`py-4 lg:px-4 opacity-0`}
  height: 100%;
  display: flex;
  align-items: center;
`

const TileIcon = styled(Icon)`
  ${tw`bg-yellow w-16 h-16 rounded-full overflow-visible p-4 mx-4 mb-8`}
`

const TileDescription = styled.div<{ isRtl: boolean }>`
  ${tw`relative px-4`}
`
const StyledBlockQuote = styled(BlockQuote)`
  ${tw`text-white`}
`
const StyledBlockQuoteWrapper = styled.div`
  ${tw`relative mx-4 px-4`}
`

const TileHeading = styled.h3`
  ${tw`text-xl font-condensed leading-tight text-white`}
`
type HomeTileType = { tile: HomeTileProps }
const HomeTile = forwardRef<HTMLDivElement, HomeTileType>(
  function HomeTileWithRef({ tile }: HomeTileType, ref) {
    const { isRtl } = useContext(LanguageContext)

    return (
      <TileContainer ref={ref}>
        {
          // eslint-disable-next-line no-underscore-dangle
          tile.__typename === "ContentfulQuoteTile" ? (
            <StyledBlockQuoteWrapper>
              <StyledBlockQuote>{tile.text}</StyledBlockQuote>
            </StyledBlockQuoteWrapper>
          ) : (
            <TileDescription isRtl={isRtl}>
              <TileHeading>
                <LastWordColoured text={tile.heading} />
              </TileHeading>
              <p>{tile.description}</p>
            </TileDescription>
          )
        }
      </TileContainer>
    )
  }
)

export default HomeTile
